import React from "react";
import img1 from "../../../Assets/Homeimgs/Masterimg.png";
import img2 from "../../../Assets/Homeimgs/Motivated.svg";
import img3 from "../../../Assets/Homeimgs/Keepup.svg";
import img4 from "../../../Assets/Homeimgs/GetCertified.svg";
import img5 from "../../../Assets/Homeimgs/BuildSkills.svg";

const MasterTheSkills = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#eef3ff] via-[#f7f5ff] to-white">
      {/* soft glows similar to UnlockYour */}
      <div className="pointer-events-none absolute -top-40 -left-32 h-80 w-80 rounded-full bg-[#064585]/25 blur-3xl" />
      <div className="pointer-events-none absolute top-32 -right-40 h-96 w-96 rounded-full bg-[#5989C8]/30 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-8 md:py-12 lg:py-14 flex flex-col lg:flex-row gap-10 lg:gap-12 items-center">
        {/* Text Content */}
        <div className="lg:w-3/5 flex flex-col justify-center">
          <p
            className="text-[10px] text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-[#064585]"
            data-aos="fade-right"
          >
            What's New
          </p>

          <h1
            className="mt-4 text-4xl md:text-5xl font-semibold leading-tight text-slate-900"
            data-aos="fade-left"
          >
            Master the{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#64a2ff] via-[#5989C8] to-[#064585]">
              Skills
            </span>{" "}
            to Drive Your Career
          </h1>

          <p
            className="mt-4 text-sm sm:text-base md:text-lg text-slate-600 max-w-xl"
            data-aos="fade-up-right"
          >
            Get certified, master modern tech skills, and level up your career —
            whether you're starting out or a seasoned pro. 95% of our learners
            report that our hands-on content directly helped their careers.
          </p>

          {/* Feature Cards - styled like UnlockYour counters */}
          <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
            <div
              className="bg-white/80 backdrop-blur rounded-2xl shadow-md border border-[#5989C8]/20 flex items-center gap-4 px-4 py-3"
              data-aos="flip-left"
            >
              <img src={img2} alt="Stay Motivated" className="w-12 h-12" />
              <h3 className="text-sm md:text-lg font-semibold text-slate-900">
                Stay Motivated with Engaging Instructors
              </h3>
            </div>

            <div
              className="bg-white/80 backdrop-blur rounded-2xl shadow-md border border-[#5989C8]/20 flex items-center gap-4 px-4 py-3"
              data-aos="flip-right"
            >
              <img src={img3} alt="Keep up with Cloud" className="w-12 h-12" />
              <h3 className="text-sm md:text-lg font-semibold text-slate-900">
                Keep up with the Latest in Cloud
              </h3>
            </div>

            <div
              className="bg-white/80 backdrop-blur rounded-2xl shadow-md border border-[#5989C8]/20 flex items-center gap-4 px-3"
              data-aos="flip-up"
            >
              <img src={img4} alt="Get Certified" className="w-12 h-12" />
              <h3 className="text-sm md:text-lg font-semibold text-slate-900">
                Get Certified with 100+ Certification Courses
              </h3>
            </div>

            <div
              className="bg-white/80 backdrop-blur rounded-2xl shadow-md border border-[#5989C8]/20 flex items-center gap-4 px-4 py-3"
              data-aos="flip-down"
            >
              <img src={img5} alt="Build Skills" className="w-12 h-12 " />
              <h3 className="text-sm md:text-lg font-semibold text-slate-900">
                Build Skills Your Way, from Labs to Courses
              </h3>
            </div>
          </div>
        </div>

        {/* Image */}
        <div className="md:w-2/5 flex justify-center" data-aos="zoom-in-down">
          <div className="bg-white/80 backdrop-blur rounded-3xl shadow-lg border border-[#5989C8]/20 p-4 flex items-center">
            <img
              src={img1}
              alt="Master the skills illustration"
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MasterTheSkills;
